module.exports = __webpack_public_path__ + "static/media/magicChime.ad9d2123.mp3";